import { getTranslations } from "../translations";
import { Popup, PopupButton, PopupPosition } from "./popup";

export interface ConfirmPopupOptions
{
    id: string;
    title: string;
    content: string;

    confirmLabel?: string;
    cancelLabel?: string;

    confirmClassName?: string;
    cancelClassName?: string;

    desktopPosition?: PopupPosition;
    mobilePosition?: PopupPosition;

    closeButton?: boolean;
    
    onConfirm: () => void;
    onCancel?: () => void;
}

export function showConfirmPopup(options: ConfirmPopupOptions): Popup
{
    const buttons: Array<PopupButton> = [];

    const cancelButton = new PopupButton();
    cancelButton.label = options.cancelLabel ?? getTranslations().txtCancel;
    cancelButton.className = options.cancelClassName ?? "btn btn-white";
    cancelButton.closeOnCLick = true;

    if (options.onCancel)
    {
        cancelButton.onClick = options.onCancel;
    }

    buttons.push(cancelButton);

    const confirmButton = new PopupButton();
    confirmButton.label = options.confirmLabel ?? getTranslations().txtConfirm;
    confirmButton.className = options.confirmClassName ?? "btn btn-green";
    confirmButton.closeOnCLick = false;
    confirmButton.onClick = () =>
    {
        options.onConfirm();
    };
    buttons.push(confirmButton);

    const popup = new Popup({
        id: options.id,
        title: options.title,
        content: options.content,
        popupClass: "g-popup__buttons--evenly",
        desktopPosition: options.desktopPosition ?? PopupPosition.Right,
        mobilePosition: options.mobilePosition ?? PopupPosition.Drawer,
        closeButton: options.closeButton ?? true,
        buttons
    });

    popup.show();

    return popup;
}